
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { X } from "lucide-react";

interface BagImageViewerProps {
  selectedImage: string | null;
  onClose: () => void;
}

export const BagImageViewer = ({ selectedImage, onClose }: BagImageViewerProps) => {
  return (
    <Dialog open={!!selectedImage} onOpenChange={onClose}>
      <DialogContent className="max-w-screen-lg w-[90vw] p-0 overflow-hidden">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 z-50 rounded-full bg-black/50 p-2 text-white hover:bg-black/70 transition-colors focus:outline-none focus:ring-2 focus:ring-white/20"
        >
          <X className="h-6 w-6" />
        </button>
        {selectedImage && (
          <img
            src={selectedImage}
            alt="Bag image"
            className="w-full h-auto object-contain max-h-[90vh]"
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
